import { render, staticRenderFns } from "./BuyBusinessDetails.vue?vue&type=template&id=72420294&scoped=true&"
import script from "./BuyBusinessDetails.vue?vue&type=script&lang=js&"
export * from "./BuyBusinessDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72420294",
  null
  
)

export default component.exports